<div class="vtr-ui-circle-radio-with-checkbox-list col-aut0 px-0"
	[ngClass]="{'white-theme': theme === 'white', 'blue-theme': theme === 'blue', 'dark-theme': theme === 'dark'}">
	<div class="circle-radio"
		[class.control-disabled]="isDisabled"
		[id]="groupName"
		#radioGroupRef
		[tabIndex]="0"
		(blur)="onRadioGroupBlur($event)"
		(focus)="onRadioGroupFocus($event)"
		(keydown)="onKeyDown($event)"
		role="radiogroup"
		[vtrDisabled]="isDisabled">
		<ng-template ngFor
			let-item
			[ngForOf]="radioDetails"
			let-index="index">
			<div class="radio-container">
				<div role="radio"
					#radioRef
					[id]="item.componentId"
					[attr.aria-checked]="item.isChecked"
					[attr.aria-disabled]="item.isDisabled || isDisabled"
					[attr.aria-label]="(item.ariaLabel) ? item.ariaLabel: item.label | translate"
					(click)="onClick($event)">
					<div *ngIf="item.componentId === focusedComponentId && item.isChecked">
						<span class="icon-state-focus" [attr.aria-hidden]=true>
						</span>
						<span class="icon-state-focus-check" [attr.aria-hidden]=true>
						</span>
						<span class="icon-state-focus-check-background" [attr.aria-hidden]=true>
						</span>
					</div>
					<div *ngIf="!item.hideIcon"
						[attr.aria-hidden]=true
						[style.cursor]="item.isDisabled?'default': 'pointer'"
						[ngClass]="'icomoon icomoon-'+getIconName(item)"></div>
					<div *ngIf="item.customIcon && item.customIcon.length>0"
						[attr.aria-hidden]=true
						[style.cursor]="item.isDisabled?'default': 'pointer'"
						[ngClass]="'icomoon icomoon-'+item.customIcon"></div>
					<fa-layers [fixedWidth]="true"
						[attr.aria-hidden]=true
						*ngIf="item.isChecked">
						<fa-icon class="icon-circle"
							[attr.aria-hidden]=true
							[class.icon-circle-disabled]="item.isDisabled"
							[icon]="['fas', 'circle']"></fa-icon>
						<fa-icon class="check-circle"
							[attr.aria-hidden]=true
							[class.check-circle-disabled]="item.isDisabled"
							[icon]="['fal', 'check']"></fa-icon>
					</fa-layers>
				</div>
				<div class="text"
					[id]="item.componentId + '-label'"
					[attr.aria-hidden]=false
					[class.text-disabled]="item.isDisabled || isDisabled"
					[innerHTML]="item.processLabel ? (item.label | translate | capitalizeFirst) : item.label | translate">
				</div>
			</div>
		</ng-template>
	</div>
</div>
